<template>
	<div class="container">
		<triangle-image
			title="Come creiamo le nostre ricette">
		</triangle-image>

		<div >
			<div class="content">

				<section>
					<div class="image">
						<object type="image/svg+xml" :data="require('../../assets/img/how-we-create/piramide.svg')">Piramide</object>
						<br><router-link :to="{ name: 'manifesto' }" class="link">Scopri il nostro manifesto</router-link>
					</div>

					<div class="description">
						<h2>Equilibrio</h2>
						<p>Nel nostro menù settimanale sono sempre presenti tante verdure e cereali, <b>alimenti alla base della piramide alimentare</b> che vanno consumati abitualmente. Gli alimenti in cima alla piramide sono presenti in quantità minore nel nostro menù: sono gustosi e sfiziosi ma vanno consumati con più moderazione.</p>
					</div>
				</section>

				<hr>

				<section>

					<div class="description">
						<h2>Stagionalità</h2>
						<p><b>Mangiare sano</b> deve essere semplice e alla portata di tutti: per questo selezioniamo con attenzione tutti i nostri prodotti. Lavoriamo con <b>ingredienti stagionali</b>, prevalentemente vegetali, non provenienti da allevamenti intensivo e poco o per nulla trasformati industrialmente.</p>
					</div>

					<div class="image">
						<object type="image/svg+xml" :data="require('../../assets/img/how-we-create/stagionalita-ingredienti.svg')">Stagionalita Ingredienti</object>
						<br><router-link :to="{ name: 'suppliers' }" class="link">Scopri i nostri produttori</router-link>
					</div>
				</section>

				<hr>

				<section>
					<div class="image">
						<object type="image/svg+xml" :data="require('../../assets/img/how-we-create/qualita.svg')">Qualita</object>
					</div>

					<div class="description">
						<h2>Gusto</h2>
						<p>Scegliamo gli ingredienti uno ad uno, <b>facendo attenzione al gusto e al territorio</b>, al fine di garantire sempre prodotti di qualità, freschissimi e genuini. Ingredienti ottimi sono la base per creare cene bilanciate e buonissime, perfette per ogni giorno della settimana.</p>
					</div>
				</section>
			</div>

		</div>
		<start-with-us></start-with-us>
	</div>
</template>

<script>

import TriangleImage from '../TriangleImage'

import StartWithUs from '../Parts/StartWithUs'

export default {
	components: {
		'triangle-image': TriangleImage,
		'start-with-us': StartWithUs
	}

}

</script>

<style scoped>
	.content > section {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between;
		max-width: 1024px;
		margin: 0px auto 30px auto;
	}

	section .image {
		min-width: 300px;
		padding: 0;
	}

	h2 {
		margin-bottom: 30px;
		text-align: left;
		font-size: 30px;
	}

	.content > section > div {
		padding: 20px 0px;
		max-width: 470px;
		margin: 0 auto;
	}

	.content > section .image {
		text-align: center;
	}

	.link {
		color: #399ec9;
	}

	.link:hover {
		color: #328fb7;
		text-decoration: underline;
	}

	.icon-contact {
		width: 35px;
		margin-right: 10px;
	}

	.contacts,
	.abo {
		display: flex;
		flex-direction: column;
		align-self: start;
		text-align: center;
	}

	.calendar {
		margin: 10px auto;
	}

	.container-faq {
		max-width: 768px;
		width: 90%;
		margin: 30px auto;
		text-align: center;

		position: relative;

		border: 1px solid #575A5C;
		border-radius: 6px;
		padding: 20px;
	}

	.container-faq .fa-question-circle {
		color: var(--quomi-primary);
		position: absolute;
		background-color: white;
		top: 0px;
		left: 50%;
		transform: translate(-50%, -50%);
		padding: 0 20px;
	}

	.container-faq .title {
		font-size: 24px;
		position: absolute;
		background-color: white;
		top: 0px;
		font-weight: normal;
		left: 50%;
		transform: translate(-50%, -100%);
		padding: 0 20px;
	}

	.faq-title {
		text-transform: uppercase;
		font-size: 15px;
		margin-top: 30px;
	}

	.container-faq h3 {
		text-transform: uppercase;
	}

	.contacts-list {
		list-style: none;
	}

	.contacts-list {
		text-align: left;
		width: 250px;
		margin: auto;
	}

	.contacts-list li {
		padding: 10px 0;
	}

	.triangle-image {
		background: url("https://api.quomi.it/oldimg/Cucina-senza-sprechi-con-Quomi.webp") center 40% no-repeat;
		background-size: cover;
	}

</style>
